import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
// icons
import { Icon } from '@iconify/react';
// @mui
import { Box } from '@mui/material';
const Iconify = forwardRef(({ icon, width = 20, sx, ...other }, ref) => (_jsx(Box, { ref: ref, component: Icon, icon: icon, sx: { width, height: width, ...sx }, ...other })));
export default Iconify;
